import React from 'react'
import type { FC } from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import type { ITheme } from '@homeviews/styles'
import { Typography, Button } from '@homeviews/shared-ui'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      '& h5': {
        marginBottom: 10,
      },
      '& p': {
        marginBottom: 20,
      },
    },
    contactBox: {
      display: 'flex',
      border: '1px solid #EBEBEB',
      borderRadius: '3px',
      overflow: 'hidden',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      padding: '15px 18px',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    contactBoxTitle: {
      marginBottom: 8,
    },
    contactBoxInner: {
      marginRight: 40,
      flex: 1,
    },
  }),
)
interface IProps {
  className?: string
}

const WidgetsFaq: FC<IProps> = ({ className }) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, className)}>
      <Typography variant="h5">What to do with your widget code?</Typography>
      <Typography>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla vitae
        elit libero, a pharetra augue. Nullam quis risus eget urna mollis ornare
        vel eu leo. Fusce dapibus, tellus ac cursus commodo, tortor mauris
        condimentum nibh, ut fermentum massa justo sit amet risus. Donec sed
        odio dui.
      </Typography>
      <Typography variant="h5">What to do with your widget code?</Typography>
      <Typography>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla vitae
        elit libero, a pharetra augue. Nullam quis risus eget urna mollis ornare
        vel eu leo. Fusce dapibus, tellus ac cursus commodo, tortor mauris
        condimentum nibh, ut fermentum massa justo sit amet risus. Donec sed
        odio dui.
      </Typography>
      <Typography variant="h5">What to do with your widget code?</Typography>
      <Typography>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla vitae
        elit libero, a pharetra augue. Nullam quis risus eget urna mollis ornare
        vel eu leo. Fusce dapibus, tellus ac cursus commodo, tortor mauris
        condimentum nibh, ut fermentum massa justo sit amet risus. Donec sed
        odio dui.
      </Typography>
      <div className={classes.contactBox}>
        <div className={classes.contactBoxInner}>
          <Typography
            variant="h3"
            color="primary"
            className={classes.contactBoxTitle}
          >
            Need help?
          </Typography>
          <Typography>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla vitae
            elit libero, a pharetra augue. Nullam quis risus eget urna mollis
            ornare vel eu leo.
          </Typography>
        </div>
        <Button variant="outlined" customVariant="outlinedPrimary">
          Contact support
        </Button>
      </div>
    </div>
  )
}

export default WidgetsFaq
